"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _overlayStyles = _interopRequireDefault(require("./overlay-styles.less"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Overlay = _ref => {
  let {
    children,
    visible
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: `${_overlayStyles.default['rprogress-overlay'] || 'rprogress-overlay'} ${visible ? _overlayStyles.default['rprogress-overlay_active'] || 'rprogress-overlay_active' : ''}`,
    children: children
  });
};
var _default = exports.default = Overlay;
//# sourceMappingURL=index.js.map